import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { baseUrlFunc } from '../../app/app.module';
import { HttpInterceptorProvider } from '../http-interceptor/http-interceptor';

/*
  Generated class for the UserProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class UserProvider {
  USER = "USER"
  apiBase = baseUrlFunc() + "wp/v2/users"
  forguetPasswordApi = baseUrlFunc() + "wp/v2/users"
  apiACFBase = baseUrlFunc() + "acf/v3/users"
  apiLoginBase = baseUrlFunc() + "custom/login"

  hasLogged = false;
  constructor(public http: HttpInterceptorProvider) {
  }

  login(username: string, password: string): Observable<any> {

    return Observable.create(observer => {

      this.http.get(this.apiLoginBase + "?username=" + username + "&password=" + password).subscribe(data => {
        observer.next(data)
        this.setUserStoraged(data);
        console.log("register success response", data);

      }, err => {
        observer.error(err)
        console.log("register error response", err)
      });
      this.hasLogged = true;
    })
  }

  registerUser(
    nome: string,
    uf: string,
    crm: string,
    especialidade: string,
    area_de_interesse: string,
    endereco: string,
    telefone: string,
    email: string,
    senha: string,
    opcao_contato: string,
    photo: string
  ): Observable<any> {

    return Observable.create(observer => {

      let bodyObj = {};
      bodyObj['name'] = nome;
      bodyObj['email'] = email;
      bodyObj['username'] = email;
      bodyObj['password'] = senha;

      let acf = {};
      acf['uf'] = uf;
      acf['crm-medico'] = crm;
      acf['especialidades_medico'] = especialidade;
      acf['areas_interesse'] = area_de_interesse;
      acf['endereco'] = endereco;
      acf['celular'] = telefone;
      acf['opcao_contato'] = opcao_contato;
      acf['foto'] = photo;

      bodyObj['acf_fields'] = acf

      this.http.post(this.apiBase, bodyObj).subscribe(data => {
        this.updateACFUser(data.id, bodyObj).subscribe(data => {
          observer.next(data)
        }, err => {
          observer.error(err)
        })
        console.log("register success response", data)
      }, err => {
        observer.error(err)
        console.log("register error response", err)
      })
      this.hasLogged = true;
    })
  }

  updateUserData(
    userId: string,
    nome: string,
    uf: string,
    crm: string,
    especialidade: string,
    area_de_interesse: string,
    endereco: string,
    telefone: string,
    email: string,
    senha: string,
    opcao_contato: string,
    photo: string
  ): Observable<any> {

    return Observable.create(observer => {

      let bodyObj = {};
      bodyObj['name'] = nome;
      bodyObj['email'] = email;
      bodyObj['username'] = email;
      bodyObj['password'] = senha;

      let acf = {};
      acf['uf'] = uf;
      acf['crm-medico'] = crm;
      acf['especialidades_medico'] = especialidade;
      acf['areas_interesse'] = area_de_interesse;
      acf['endereco'] = endereco;
      acf['celular'] = telefone;
      acf['opcao_contato'] = opcao_contato;
      acf['foto'] = photo;

      bodyObj['acf_fields'] = acf

      this.http.post(this.apiBase + "/" + userId, bodyObj).subscribe(data => {
        this.updateACFUser(userId, bodyObj).subscribe(data => {
          this.updatePersistedUser(nome, uf, crm, especialidade, area_de_interesse, endereco, telefone, email, opcao_contato, photo)
          
          observer.next(data)
        }, err => {
          observer.error(err)
        })
        console.log("register success response", data)
      }, err => {
        observer.error(err)
        console.log("register error response", err)
      })
      this.hasLogged = true;
    })
  }

  updateACFUser(userid: string, user: any): Observable<any> {
    return Observable.create(observer => {

      this.http.post(this.apiACFBase + "/" + userid, user).subscribe(data => {
        observer.next(data)
        console.log("updateACFUser success response", data)
      }, err => {
        observer.error(err)
        console.log("updateACFUser error response", err)
      })
      this.hasLogged = true;
    })
  }

  editUser(
    nome: string,
    uf: string,
    crm: string,
    especialidade: string,
    area_de_interesse: string,
    endereco: string,
    telefone: string,
    email: string,
    senha: string,
    opcao_contato: string,
    photo: string
  ): Observable<any> {

    return Observable.create(observer => {
      let bodyObj = {};
      bodyObj['username'] = nome;
      bodyObj['email'] = email;
      bodyObj['password'] = senha;

      let acf = {};
      acf['uf'] = uf;
      acf['crm-medico'] = crm;
      acf['especialidades_medico'] = especialidade;
      acf['areas_interesse'] = area_de_interesse;
      acf['endereco'] = endereco;
      acf['celular'] = telefone;
      acf['opcao_contato'] = opcao_contato;
      acf['foto'] = photo;

      bodyObj['acf'] = acf

      this.http.put(this.apiBase + "?", bodyObj).subscribe(data => {
        observer.next(data)
        console.log("register success response", data)
      }, err => {
        observer.error(err)
        console.log("register error response", err)
      })
    })
  }

  recuperarSenha(email: string): Observable<any> {
    return Observable.create(observer => {

      let bodyObj = {}
      bodyObj['email'] = email;

      this.http.post(this.apiBase + "?", bodyObj).subscribe(data => {
        observer.next(data)
        console.log("register success response", data)
      }, err => {
        observer.error(err)
        console.log("register error response", err)
      })
      this.hasLogged = true;
    })
  }

  setUserStoraged(user: any) {
    window.localStorage.setItem(this.USER, JSON.stringify(user))
  }

  getUserStoraged(): any {
    return JSON.parse(window.localStorage.getItem(this.USER))
  }

  logout(){
    window.localStorage.removeItem(this.USER)
  }

  updatePersistedUser(
    nome: string,
    uf: string,
    crm: string,
    especialidade: string,
    area_de_interesse: string,
    endereco: string,
    telefone: string,
    email: string,
    opcao_contato: string,
    photo: string) {

    let user = this.getUserStoraged()

    user.general.data.display_name = nome
    user.general.data.user_login = email
    user.acf["uf"] = uf
    user.acf["crm-medico"] = crm
    user.acf["especialidades_medico"] = especialidade
    user.acf["areas_interesse"] = area_de_interesse
    user.acf["endereco"] = endereco
    user.acf["celular"] = telefone
    user.acf["opcao_contato"] = opcao_contato
    user.acf["foto"] = photo

    this.setUserStoraged(user)

  }

  forguetPassword(username: string): Observable<any> {

    return Observable.create(observer => {

      this.http.get(this.apiLoginBase + "?username=" + username ).subscribe(data => {
        observer.next(data)
        this.setUserStoraged(data);
        console.log("register success response", data);

      }, err => {
        observer.error(err)
        console.log("register error response", err)
      });
      this.hasLogged = true;
    })
  }

  hasUserLogged(): boolean {
    return this.getUserStoraged() != undefined
  }

}



// WEBPACK FOOTER //
// ./src/providers/user/user.ts